"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/babel-runtime/helpers/classCallCheck.js
// module id = 4WdS
// module chunks = 6